import { makeStyles } from '@material-ui/core/styles';
import { COLORS, SPACING } from '../constants';

export const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    overflow: 'auto',
    padding: SPACING.sectionGap,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  emptyState: {
    padding: 20,
    textAlign: 'center',
    color: COLORS.muted,
    fontSize: 13,
    background: COLORS.white,
    borderRadius: 6,
    border: `1px dashed ${COLORS.border}`,
  },
  templateCard: {
    background: COLORS.white,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 6,
    padding: `${SPACING.cardPadding}px ${SPACING.cardPaddingHorizontal}px`,
    display: 'flex',
    alignItems: 'center',
    gap: SPACING.detailGap,
    marginBottom: SPACING.cardMarginBottom,
  },
  templateIcon: {
    width: 40,
    height: 40,
    borderRadius: 8,
    background: COLORS.primaryLight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    flexShrink: 0,
  },
  templateContent: {
    flex: 1,
    minWidth: 0,
  },
  templateName: {
    fontSize: 15,
    fontWeight: 600,
    color: COLORS.body,
    marginBottom: SPACING.detailGap,
  },
  templateDesc: {
    fontSize: 12,
    color: COLORS.muted,
    marginBottom: 4,
  },
  templateMeta: {
    display: 'flex',
    gap: SPACING.detailGap,
    fontSize: 12,
  },
  templateActions: {
    display: 'flex',
    gap: 8,
    flexShrink: 0,
  },
}));
